import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "box"]

  connect() {
    this.submitting = false
    this.form = this.inputTarget.closest("form")
    this.form.addEventListener("submit", this.preventDoubleSubmit)
    this.form.addEventListener("turbo:submit-end", this.allowResubmit)
    this.inputTarget.focus()
  }

  disconnect() {
    this.form.removeEventListener("submit", this.preventDoubleSubmit)
    this.form.removeEventListener("turbo:submit-end", this.allowResubmit)
    this.boxTargets.forEach((box) => { box.textContent = "" })
  }

  onInput() {
    const filtered = this.inputTarget.value.replace(/\D/g, "").slice(0, 6)
    if (filtered !== this.inputTarget.value) {
      this.inputTarget.value = filtered
    }
    this.#updateBoxes()

    if (filtered.length === 6) {
      this.form.requestSubmit()
    }
  }

  // The form auto-submits on the sixth digit, so pressing Enter or a password
  // manager submitting as well would send the code a second time.
  preventDoubleSubmit = (event) => {
    if (this.submitting) {
      event.preventDefault()
      event.stopImmediatePropagation()
    } else {
      this.submitting = true
    }
  }

  allowResubmit = (event) => {
    if (!event.detail.success) {
      this.submitting = false
    }
  }

  #updateBoxes() {
    const value = this.inputTarget.value
    const caretPos = this.inputTarget.selectionStart

    this.boxTargets.forEach((box, i) => {
      box.textContent = value[i] || ""
      box.classList.toggle("border-primary", i === caretPos && value.length < 6)
      box.classList.toggle("border-input", i !== caretPos || value.length >= 6)
    })
  }
}
